import v1 from "./v1.js";
import v2 from "./v2.js";

export default [v1, v2];
